// extracted by mini-css-extract-plugin
export default {"keypad":"Keypad_keypad__95+nC","key":"Keypad_key__aOG5I","digit":"Keypad_digit__MrTo2","sub":"Keypad_sub__vtsZN"};